import axios from 'axios';
import {
    room,
    electronConfig,
    convertPath,
    isElectron,
    strTest
} from '../libs/roomnew';
import SuccessYellow from '../components/Icons/SuccessYellow';
import TipsYellow from '../components/Icons/TipsYellow';

const KinoLogoWhite=`<svg width="350" height="140" viewBox="0 0 654 250" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M125 250C194.036 250 250 194.036 250 125C250 55.9644 194.036 0 125 0C55.9644 0 0 55.9644 0 125C0 194.036 55.9644 250 125 250Z" fill="#fff"></path><path d="M67.2454 54.7454H84.0856V195.197H67.2454V54.7454V54.7454ZM157.465 54.7454H178.935L119.155 121.701L182.755 195.255H160.764L101.852 127.72C99.5949 125.174 99.5949 121.354 101.852 118.75L157.465 54.7454Z" fill="#032836"></path><path d="M316.637 94.8867L299.254 112.953V161H280.504V18.8125H299.254V89.125L362.438 18.8125H385.094L329.137 81.6055L389.488 161H367.027L316.637 94.8867ZM422.691 161H404.625V55.3359H422.691V161ZM403.16 27.3086C403.16 24.3789 404.039 21.9049 405.797 19.8867C407.62 17.8685 410.289 16.8594 413.805 16.8594C417.32 16.8594 419.99 17.8685 421.812 19.8867C423.635 21.9049 424.547 24.3789 424.547 27.3086C424.547 30.2383 423.635 32.6797 421.812 34.6328C419.99 36.5859 417.32 37.5625 413.805 37.5625C410.289 37.5625 407.62 36.5859 405.797 34.6328C404.039 32.6797 403.16 30.2383 403.16 27.3086ZM468.785 55.3359L469.371 68.6172C477.444 58.4609 487.991 53.3828 501.012 53.3828C523.342 53.3828 534.605 65.9805 534.801 91.1758V161H516.734V91.0781C516.669 83.4609 514.911 77.8294 511.461 74.1836C508.076 70.5378 502.77 68.7148 495.543 68.7148C489.684 68.7148 484.54 70.2773 480.113 73.4023C475.686 76.5273 472.236 80.6289 469.762 85.707V161H451.695V55.3359H468.785ZM557.262 107.191C557.262 96.8398 559.28 87.5299 563.316 79.2617C567.418 70.9935 573.082 64.6133 580.309 60.1211C587.6 55.6289 595.901 53.3828 605.211 53.3828C619.599 53.3828 631.22 58.3633 640.074 68.3242C648.993 78.2852 653.453 91.5339 653.453 108.07V109.34C653.453 119.626 651.467 128.871 647.496 137.074C643.59 145.212 637.958 151.56 630.602 156.117C623.31 160.674 614.911 162.953 605.406 162.953C591.083 162.953 579.462 157.973 570.543 148.012C561.689 138.051 557.262 124.867 557.262 108.461V107.191ZM575.426 109.34C575.426 121.059 578.128 130.466 583.531 137.562C589 144.659 596.292 148.207 605.406 148.207C614.586 148.207 621.878 144.626 627.281 137.465C632.685 130.238 635.387 120.147 635.387 107.191C635.387 95.6029 632.62 86.2279 627.086 79.0664C621.617 71.8398 614.326 68.2266 605.211 68.2266C596.292 68.2266 589.098 71.7747 583.629 78.8711C578.16 85.9674 575.426 96.1237 575.426 109.34Z" fill="#fff"></path><path d="M310.103 207.885C310.103 213.65 308.826 218.23 306.274 221.625C303.722 224.997 300.293 226.684 295.986 226.684C290.837 226.684 286.94 224.77 284.297 220.941L284.126 226H280.298V173.5H284.365V194.384C286.963 190.351 290.814 188.334 295.918 188.334C300.293 188.334 303.745 190.009 306.274 193.358C308.826 196.685 310.103 201.322 310.103 207.27V207.885ZM306.001 207.167C306.001 202.291 305.055 198.531 303.164 195.888C301.273 193.222 298.607 191.889 295.166 191.889C292.546 191.889 290.324 192.538 288.501 193.837C286.678 195.113 285.299 196.993 284.365 199.477V216.156C286.416 220.805 290.039 223.129 295.234 223.129C298.607 223.129 301.239 221.796 303.13 219.13C305.044 216.464 306.001 212.476 306.001 207.167ZM330.474 220.121L341.274 189.018H345.684L329.893 232.289L329.072 234.203C327.044 238.692 323.911 240.937 319.673 240.937C318.693 240.937 317.645 240.777 316.528 240.458L316.494 237.074L318.613 237.279C320.618 237.279 322.236 236.778 323.467 235.775C324.72 234.796 325.78 233.098 326.646 230.683L328.457 225.692L314.512 189.018H318.989L330.474 220.121ZM381.23 201.288L374.224 208.192V226H370.02V176.234H374.224V203.065L399.722 176.234H405.02L384.17 198.383L406.626 226H401.499L381.23 201.288ZM417.803 226H413.701V189.018H417.803V226ZM412.983 178.319C412.983 177.545 413.234 176.895 413.735 176.371C414.237 175.824 414.92 175.551 415.786 175.551C416.652 175.551 417.336 175.824 417.837 176.371C418.361 176.895 418.623 177.545 418.623 178.319C418.623 179.094 418.361 179.743 417.837 180.268C417.336 180.792 416.652 181.054 415.786 181.054C414.92 181.054 414.237 180.792 413.735 180.268C413.234 179.743 412.983 179.094 412.983 178.319ZM432.842 189.018L432.979 195.341C434.368 193.062 436.1 191.33 438.174 190.146C440.247 188.938 442.537 188.334 445.044 188.334C449.009 188.334 451.96 189.451 453.896 191.684C455.833 193.917 456.813 197.266 456.836 201.732V226H452.769V201.698C452.746 198.394 452.039 195.933 450.649 194.315C449.282 192.698 447.083 191.889 444.053 191.889C441.523 191.889 439.279 192.686 437.319 194.281C435.382 195.854 433.947 197.984 433.013 200.673V226H428.945V189.018H432.842ZM481.753 226.684C478.608 226.684 475.76 225.909 473.208 224.359C470.679 222.81 468.708 220.657 467.295 217.899C465.882 215.119 465.176 212.009 465.176 208.568V207.099C465.176 203.544 465.859 200.342 467.227 197.494C468.617 194.646 470.542 192.413 473.003 190.795C475.464 189.154 478.13 188.334 481.001 188.334C485.49 188.334 489.045 189.872 491.665 192.948C494.308 196.002 495.63 200.183 495.63 205.492V207.782H469.243V208.568C469.243 212.761 470.439 216.259 472.832 219.062C475.247 221.841 478.278 223.231 481.924 223.231C484.111 223.231 486.037 222.833 487.7 222.035C489.386 221.238 490.913 219.962 492.28 218.207L494.844 220.155C491.836 224.507 487.472 226.684 481.753 226.684ZM481.001 191.82C477.925 191.82 475.327 192.948 473.208 195.204C471.112 197.46 469.836 200.491 469.38 204.296H491.562V203.852C491.449 200.297 490.435 197.403 488.521 195.17C486.606 192.937 484.1 191.82 481.001 191.82ZM509.951 179.55V189.018H517.607V192.367H509.951V217.011C509.951 219.062 510.316 220.588 511.045 221.591C511.797 222.593 513.039 223.095 514.771 223.095C515.454 223.095 516.559 222.981 518.086 222.753L518.257 226.103C517.186 226.49 515.728 226.684 513.882 226.684C511.079 226.684 509.04 225.875 507.764 224.257C506.488 222.616 505.85 220.212 505.85 217.045V192.367H499.048V189.018H505.85V179.55H509.951ZM537.705 204.022L547.686 189.018H552.539L539.995 207.167L553.086 226H548.267L537.739 210.346L527.212 226H522.393L535.449 207.167L522.905 189.018H527.725L537.705 204.022ZM613.345 210.482C612.775 215.723 610.895 219.734 607.705 222.514C604.538 225.294 600.311 226.684 595.024 226.684C591.333 226.684 588.063 225.761 585.215 223.915C582.389 222.069 580.202 219.46 578.652 216.088C577.103 212.693 576.317 208.819 576.294 204.467V198.007C576.294 193.586 577.069 189.667 578.618 186.249C580.168 182.831 582.389 180.199 585.283 178.354C588.2 176.485 591.549 175.551 595.332 175.551C600.664 175.551 604.868 176.998 607.944 179.892C611.043 182.763 612.843 186.739 613.345 191.82H609.106C608.058 183.367 603.467 179.14 595.332 179.14C590.82 179.14 587.22 180.826 584.531 184.198C581.865 187.571 580.532 192.23 580.532 198.178V204.262C580.532 210.004 581.831 214.584 584.429 218.002C587.049 221.42 590.581 223.129 595.024 223.129C599.422 223.129 602.738 222.081 604.971 219.984C607.204 217.865 608.582 214.698 609.106 210.482H613.345ZM620.352 206.962C620.352 203.407 621.035 200.206 622.402 197.357C623.792 194.509 625.741 192.299 628.247 190.727C630.776 189.132 633.636 188.334 636.826 188.334C641.748 188.334 645.736 190.066 648.789 193.529C651.842 196.97 653.369 201.539 653.369 207.235V208.09C653.369 211.667 652.674 214.892 651.284 217.763C649.917 220.611 647.98 222.81 645.474 224.359C642.967 225.909 640.107 226.684 636.895 226.684C631.995 226.684 628.008 224.963 624.932 221.522C621.878 218.059 620.352 213.479 620.352 207.782V206.962ZM624.453 208.09C624.453 212.51 625.592 216.145 627.871 218.993C630.173 221.819 633.18 223.231 636.895 223.231C640.586 223.231 643.571 221.819 645.85 218.993C648.151 216.145 649.302 212.396 649.302 207.748V206.962C649.302 204.136 648.778 201.55 647.729 199.203C646.681 196.856 645.212 195.045 643.32 193.769C641.429 192.47 639.264 191.82 636.826 191.82C633.18 191.82 630.207 193.256 627.905 196.127C625.604 198.975 624.453 202.712 624.453 207.338V208.09Z" fill="#fff"></path></svg>`
export default class Feedback{
    constructor(){
        this.modal = null;
        this.timeout = 0;
        this.rating = 0;

        this.kinoLogoPath = `${isElectron ?'../..': '' }/images/kino-by-kinetx.svg`;
        this.starIcon = `<i class="rating__icon rating__icon--star fa fa-star"></i>`;

        this.events();
    }

    events(){
        let f = this;
        let timeout;

        $('.rating__input').on('click', function(){
            f.rating = parseInt($(this).val());
            f.generalError.html('');
            f.inputsError.html('');
            f.emailError.html('');
            f.textContainer.addClass('d-flex')
            f.feedback.addClass('h-auto')
            f.feedbackDescription.addClass('d-none')
            timeout = setTimeout(() => {
                f.textContainer.addClass('expanded')
            }, 50);
            f.inputsSection.addClass('d-flex')
            if(f.rating <= 3){
                f.textArea.attr('placeholder', 'Let us know how we can improve.')
            }else{
                f.textArea.attr('placeholder', 'Let us know how we can improve. (Optional)')
            }
        })

    }

    renderModal(){
        let f = this;

        f.submitButton = $('<button/>',{
            class: 'btn kino-btn-primary send rounded-10 py-1',
            style:'width:180px;font-size:15px',
            html: 'Send Feedback'
        }).on('click', function(){
            f.sendFeedback();
        })
        f.homeButton = $('<button/>',{
            class: 'btn btn-light kino-btn-secondary',
            html: '<i class="fa fa-home" aria-hidden="true"></i> kino.live'
        }).on('click', function(){
            if(isElectron){
                location.href=api.global.dirname+'src/html/pages/welcome.ejs';
            }else{
                window.location.replace('/');
            }
        })
        f.actionButtons = $('<div/>',{
            class: 'align-items-center d-flex feedback-btn justify-content-center my-0 pb-0',
            html: [f.submitButton]
        })

        f.generalError = $('<span/>',{
            class: 'rating-error d-none',
            html: ''
        })
        f.emailInput = $('<input/>',{
            type: 'email',
            class: 'feedback-mail',
            placeholder: 'Email (Optional)',
            name: "feedback-mail"
        }).on('input', function(){
            f.emailError.html('')
        }).on('keyup', function(e){
            e.preventDefault();
            e.stopPropagation();
            if(e.keyCode == '13'){
                f.sendFeedback();
            }
        })
        f.inputsError = $('<span/>',{
            class: 'rating-description-error',
            html: ''
        })
        f.emailError = $('<span/>',{
            class: 'rating-description-error',
            html: ''
        })
        f.textArea = $('<textarea/>',{
            class:'w-100',
            name: "feedback",
            cols: "40",
            rows: "3",
            placeholder: "Let us know how we can improve."
        }).on('input', function(){
            f.inputsError.html('')
        }).on('keyup', function(e){
            e.preventDefault();
            e.stopPropagation();
            if(e.keyCode == '13'){
                f.sendFeedback();
            }
        })
        f.inputsSection = $('<div/>',{
            class: 'feedback-text ignore-drag',
            html: [f.textArea, f.inputsError, f.emailInput, f.emailError]
        })
        f.feedbackText = $('<h6/>',{
            html: ''
        })
        f.textContainer = $('<div/>',{
            class: 'form-step2',
            html: [f.feedbackText, f.inputsSection]
        })
        f.ratingGroup = $('<div/>',{
            class: 'rating-group ignore-drag my-2',
            html: ''
        })
        f.starForm = $('<div/>',{
            class: 'rating_form m-0',
            html: [f.ratingGroup, f.textContainer,f.actionButtons]
        })
        f.feedbackTitle = $('<p/>',{
            class: 'kino-color-primary ignore-drag text-16 font-weight-normal mt-3 text-center noselect',
            html: `Share your thoughts with team`
        })
        f.feedbackDescription=$("<p/>",{
            class:'mb-0 px-2 text-center noselect text-black',
            html:`How was your Kino experience? <br> We love feedback, it’s how we get better.`
        })
        const feedbackFooter=$("<div/>",{
            class:'w-100 feedback-footer-btn',
            html:f.homeButton
        })
        f.feedback = $('<div/>',{
            class: 'feedback w-100',
            html: [f.feedbackTitle,f.feedbackDescription,f.starForm, f.generalError,feedbackFooter]
        })

        const feedbackSection=$("<div/>",{
            class:'align-items-center d-flex flex-column justify-content-center p-4 w-50 hero-background position-relative modal-feedback-section',
            html:[f.feedback]
        })


        const learnMoreTitle=$("<p/>",{
            class: 'font-weight-normal mb-0 mt-3 px-2 mb-3 text-center text-16',
            html: 'Wondering if Kino is the one?'
        })
        const learnMoreDescription=$("<p/>",{
            class: 'mb-0 px-2 text-center text-14 noselect',
            html: `Share your email below and let's dive deeper to see if Kino aligns perfectly with your needs!`
        })
        f.learnMoreEmail=$('<input/>',{
            class:'form-control mt-3 border-yellow feedback-learn-more-input',
            type:'email',
            placeholder:"Your email"
        }).on('input',()=>{
            f.learnMoreError.html('')
        })

        f.learnMoreError=$('<span/>',{
            class:'text-danger',
            html:``
        })

        const sendEmailButton=$("<button/>",{
            class:'btn btn-yellow mt-3',
            html:'COUNT ME IN'
        }).on('click',()=>{
            this.submitLearnMoreEmail()
        })
        /**
         * <p class="font-weight-normal mb-0 mt-3 px-2 text-center text-xxl">Learn more about Kino!</p>
                        <p class="mb-0 px-2 text-center">Drop your email below to discover the full potential of Kino's Executive Workspace. Let's explore together!</p>
         */
        //section for signed in user
        const tipsTitle=$("<p/>",{
            class: 'font-weight-normal mb-0 mt-0 px-2 mb-0 text-center text-20 noselect shadow-text',
            html: `Join our AI workshop Two session event`
        })
        const eventDescription=$("<p/>",{
            class: 'font-weight-bold px-2 text-center text-17 noselect shadow-text discover-simplicity',
            style:`margin-top: 34px !important; margin-bottom: 28px !important;`,
            html: `Discover the simplicity <br><span class="yellow-text">ChatGPT</span> & Support a cause.`
        })

        const bringThemHomeNow=$("<p/>",{
            class: 'font-weight-bold mb-0 mt-3 px-2 mb-3 text-center text-16 noselect shadow-text bring-them-home-now',
            html: `BRING THEM HOME NOW!`
        })

        const bringThemHomeImage=$('<img/>',{
            style:"width:78px;border-radius: 12px;",
            src: `${isElectron ?'../..': '' }/images/event/bring-them-home.jpg`,
        })
        // const createWorkspaceItem=$('<li/>',{
        //     class:'tips-list-item',
        //     html:`<a href="#" class="tips-link">Collaborate with your team.</a>`
        // })

        // const scheduleKinoItem=$('<li/>',{
        //     class:'tips-list-item',
        //     html:`<a href="#" class="tips-link">Schedule your meetings.</a>`
        // })

        // const privateKinoItem=$('<li/>',{
        //     class:'tips-list-item',
        //     html:`<a href="#" class="tips-link">Keep everything private.</a>`
        // })

        // const TipsList=$("<ul/>",{
        //     class:'tips-list px-4',
        //     html:[
        //         createWorkspaceItem,
        //         scheduleKinoItem,
        //         privateKinoItem
        //     ]
        // })

        // const handbookDescription=$('<p/>',{
        //     class:`mt-3 mb-0 px-2 text-center text-14 noselect bring-them-home-now`,
        //     html:`There is more! Download our handbook there is everything you need to know about Kino.`
        // })
        const downloadHandbook=$("<button/>",{
            class:'btn btn-yellow mt-3 text-20 py-1',
            html:'LEARN MORE'
        }).on('click',()=>{
            if(isElectron){
                window.open(api.global.app_url+'/aiworkshop','_blank')
            }else{
                location.href='/aiworkshop';
            }
        })

        const signedInUserTips=$("<div/>",{
            class:'align-items-center d-flex flex-column justify-content-center',
            html:[KinoLogoWhite]
        });
        //
        const learnMoreColumn=$("<div/>",{
            class:'align-items-center d-flex flex-column justify-content-center',
            html:[learnMoreTitle,learnMoreDescription,f.learnMoreEmail,f.learnMoreError,sendEmailButton]
        })
        f.learnMoreThankYou=$("<div/>",{
            class:`align-items-center d-flex flex-column justify-content-center`,
            html:[
                SuccessYellow,
                `<p class="font-weight-normal mb-0 mt-3 px-2 mb-3 text-center text-16 noselect">We are all set</p>`,
                `<p class="mb-0 px-2 text-center text-14 noselect">Thank you for sharing your email, we will get back to you soon.</p>`
            ]
        })
        f.learnMoreSection=$("<div/>",{
            class:`d-flex justify-content-center align-items-center w-50 colored-left-modal py-4 px-2  modal-learn-more-section`,
            html:signedInUserTips
        })
        const modalSections=$("<div/>",{
            class:'d-flex align-items-strech h-100 feedback-modal-sections',
            html:[f.learnMoreSection,feedbackSection]
        })
        const modalAbsolute=$("<div/>",{
            class:'absolute-modal-body',
            html:[modalSections]
        })
        const modalBox=$("<div/>",{
            class:'w-100 modal-feedback-box',
            style:'height:350px',
            html:[modalAbsolute]
        })

        f.modalBody = $('<div/>',{
            class: 'modal-body feedback-modal-body w-100 ignore-drag',
            html: modalBox
        })

        // f.kinoLogo = $('<img/>',{
        //     class: 'modal-kino-logo',
        //     src: f.kinoLogoPath
        // })
        f.modalHeader = $('<div/>',{
            class: 'modal-header feedback-modal-header modal-kino',
            html: ''
        })
        f.modalContent = $('<div/>',{
            class: 'modal-content feedback-modal-content border-0',
            html: [f.modalHeader, f.modalBody]
        })
        f.modalInner = $('<div/>',{
            class: 'modal-dialog modal-dialog-centered feedback-modal-dialog modal-lg',
            style: 'max-width: 800px !important;',
            role: 'document',
            html: f.modalContent
        })
        f.modal = $('<div/>',{
            class:"modal fade",
            tabindex: "-1",
            role: "dialog",
            'aria-modal': "true",
            'aria-hidden': "true",
            'data-backdrop': "static",
            'data-keyboard': "false",
            html: f.modalInner
        })
        f.addStars();
        $('body').append(f.modal);
        f.modal.modal('show');
        f.events();
    }

    removeModal(){
        let f = this;
        f.timeout = setTimeout(() => {
            if(f.modal){
                f.modal.remove();
            }
            clearTimeout(f.timeout);
        }, 200);
    }

    addStars(){
        let f = this;
        for(let i=0; i<=5; i++){
            // console.log(i);
            f.ratingGroup.append(`
                ${i==0 ? '' : `<label aria-label="${i} star" class="rating__label" for="rating-${i}">${f.starIcon}</label>`}
                <input
                    ${i==0 ? 'disabled checked': ''}
                    class="rating__input ${i==0 ? 'rating__input--none' : ''}"
                    id="${i==0 ? 'rating-none': `rating-${i}`}"
                    name="rating"
                    value="${i}"
                    type="radio" />
            `)
        }
    }

    submitLearnMoreEmail(){
        const email = this.learnMoreEmail.val();
        if(email.length == 0 && !strTest.isValidEmail(email)) {
            this.learnMoreError.html(`Please enter a valid email`)
        }
        const name = this.splitName(MY_NAME)
        axios.post(convertPath('/lead/create'),{
            'first_name':name.first_name,
            'last_name':name.last_name,
            'email':email,
            'reference': "Feedback Modal"
        }).then(r=>{
            this.learnMoreSection.html(this.learnMoreThankYou)
            console.log("email submited",r.data)
        })
    }

    splitName(fullName){
        // Split the full name by space character
        const nameParts = fullName.split(" ");

        // Check if there are at least two parts (first and last name)
        if (nameParts.length >= 2) {
            // Extract first and last name
            const first_name = nameParts[0];
            const last_name = nameParts[nameParts.length - 1];
            // Return an object with the first and last name
            return {
                first_name,
                last_name
            };
        } else {
            // If there are not enough parts, return null
            return {
                first_name:'',
                last_name:nameParts.length > 0 ? nameParts[0] : 'Guest'
            };
        }
    }

    async sendFeedback() {
        let f = this;
        var text = f.textArea.val();
        var mail = f.emailInput.val();
        f.submitButton.prop({'disabled': true,})

        if((mail != '' && !strTest.isValidEmail(mail)) || f.rating == 0 || (f.rating <= '3' && text == '')){
            if(mail != '' && !strTest.isValidEmail(mail)){
                f.emailError.html('⚠ Please enter a valid email')
            }
            if(f.rating == 0){
                f.generalError.html('⚠ Rating is required')
            }
            if(f.rating <= '3' && text == ''){
                f.inputsError.html('⚠ Feedback is required');
            }
            f.submitButton.prop({'disabled': false,})
            return;
        }

        axios.post(convertPath(`/feedback/${isElectron ? 'add' : 'store'}`),{
            room_id: ROOM_NAME,
            guest_id: USER_ID,
            name: MY_NAME,
            message: text,
            stars: f.rating,
            email: mail
        }, await electronConfig()).then((request)=>{
            // console.log(request)
            // console.log(request.data)
            if(request.data.success){
                $('.rating__input').off('click')
                $('.feedback .rating-group').css('pointer-events','none')
                $('.rating__input').css('pointer-events','none')
                $('.rating__label').css('pointer-events','none')
                // f.feedbackText.html('We appreciate your feedback!')
                f.actionButtons.remove();
                f.textContainer.remove();
                f.feedbackTitle.html(`We hear you!`)
                f.feedbackDescription.html(`Thank you for taking the time to provide feedback. Your input is valuable to us.`).removeClass('d-none');
            }
        }).catch((err)=>{
            f.submitButton.prop({'disabled': false,})
        })

        // setTimeout(() => {
        //     if(isElectron){
        //         location.href=api.global.dirname+'src/html/pages/welcome.ejs';
        //     }else{
        //         window.location.replace('/');
        //     }
        // }, 3000);
    }

}
